import { createClient } from '@supabase/supabase-js';
var supabaseUrl = 'https://cemtccfulgwewdptkukt.supabase.co';
var supabaseAnonKey = 'sb_publishable_JIjdKk8WElQRLsIx4IC0Sg_TS1cB-6T';
export var supabase = createClient(supabaseUrl, supabaseAnonKey);
